export default __webpack_public_path__ + "d355b6c5aeed3aca7fb086fcce7798ac.webp";